import React from 'react'
import PropTypes from 'prop-types';
import Messaging from 'packages/react/messaging';

/**
 * @description Message bus for React components, pass in an 'event' with callback;
 * @type Higher order component
 * @class Connected
 * @param ComposedComponent Component to wrap;
 * @example
 * expects events 'prop'.
 * Events {object} => { 'event name': 'prop to map to' }
 * <Connected events={{'data:search-suggestion:on-suggestion-complete': 'rangeStart'}} />
 */
const Connected = ComposedComponent => class Connected extends React.Component {

    constructor(props) {
        super(props);
        if (props) {
            this.state = {
                // translate object of props to state;
                // Event starts with a prop to be mapped to;
                internalEvents: Object.assign({},
                    ...Object
                        .keys(props.events)
                        .map(event => {
                            if (!props.events[event]) {
                                console.warn(`There was no prop supplied to ${props.event[event]}`)
                            }
                            return {
                                [event]: {
                                    prop: props.events[event]
                                }
                            }
                        }))
            }
        } else {
            console.warn('No props supplied to ConnectedComponent - does this need to be wrapped?')
        }

        //connect to messaging system;
        this.messages = new Messaging;
    }

    componentDidMount() {
        const {
            events
        } = this.props;

        this.messages.subscribe(Object.keys(events), this.handleEvent);
    }

    componentWillUnmount() {
        this.messages.teardown();
    }

    handleEvent = (event, payload) => {
        this.setState({
            internalEvents: {
                ...this.state.internalEvents,
                [event.type]: {
                    ...this.state.internalEvents[event.type],
                    ts: event.timeStamp,
                    payload: payload
                }
            }
        });
    };

    publishEvent = (event, payload) => {
        this.messages.publish(event, payload);
    }

    render() {

        const {
            internalEvents
        } = this.state;

        /**
         * Here we map internal state to props
         * If a prop is passed this is the default value passed to the wrapped component
         * If an event is updated and contains 'prop' value, we update that in state and pass it as a prop to the wrapped component
         */
        const stateToProps = () => {
            //copy props;
            let ComposedProps = { ...this.props };
            delete ComposedProps.events;

            if (!internalEvents) {
                return ComposedProps;
            };

            Object.keys(internalEvents).map(event => {
                let thisEvent = internalEvents[event];
                if (thisEvent.prop && thisEvent.payload) {
                    ComposedProps[thisEvent.prop] = thisEvent.payload;
                }
            });

            return ComposedProps;
        }

        const wrappedComponentProps = stateToProps();
        return <ComposedComponent
            {...wrappedComponentProps}
            publishEvent={this.publishEvent} />;
    }
};

Connected.propTypes = {
    events: PropTypes.array.isRequired
};

export default Connected;





// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/connected/connected.jsx